import React from 'react';

import classes from './Burger.module.css';

import BurgerIngredient from './BurgerIngredient/BurgerIngredient';
import Scrollbar from '../UI/Scrollbar/Scrollbar';

const Burger = (props) => {
	let burgerIngredients = [];
	if (props.ingredients) {
		burgerIngredients = Object.keys(props.ingredients)
			.map((ingredient) => {
				return [...Array(props.ingredients[ingredient])].map((_, index) => {
					return (
						<BurgerIngredient
							type={ingredient}
							key={ingredient + '_' + (index + 1)}
						/>
					);
				});
			})
			.reduce((prev, curr) => {
				return prev.concat(curr);
			}, []);
	}

	if (burgerIngredients.length === 0) {
		burgerIngredients = <p>Please start adding ingredients to burger.</p>;
	}

	return (
		<div className={classes.Burger}>
			<Scrollbar overflowY="auto">
				<BurgerIngredient type="bread-top" />
				{burgerIngredients}
				<BurgerIngredient type="bread-bottom" />
			</Scrollbar>
		</div>
	);
};

export default Burger;
